module.exports = __webpack_public_path__ + "ddaff46cdcc491529e60b2d6ea04d046.jpg";